// extracted by mini-css-extract-plugin
module.exports = {"maindiv":"PaymentScreen_maindiv__2ZvZ-"};